<template>
    <div class="most-popular">
        <div class="container">
            <br />
            <br />
            <h2>{{tr.most_popular}}</h2>
            <div class="posts row">
                <div class="col-sm-4 post" :key="idx" v-for="(post,idx) in posts" @click="openPost(post)">
                    <div class="preview" :style="{backgroundImage:`url(${post.preview}?w=350)`}">
                        <img src="data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAABCAQAAABeK7cBAAAAC0lEQVR42mNkAAIAAAoAAv/lxKUAAAAASUVORK5CYII=" alt="" class="stretch">
                </div>
                        <div class="title">{{post.content[lang].title}}</div>
                    </div>
                </div>
            </div>
            <br />
            <br />
        </div>
</template>
<script>
//import posts from "../assets/json/posts.json";
export default {

    name: 'most-popular',
    methods: {
        openPost(post) {
            location.href = "/#/posts/" + post._id;
        }
    },
    computed: {
        lang() { return this.$store.state.lang; },
        posts() {
            let { lang } = this;
            return this.$store.getters.mostPopular.filter(p => { return p.content[lang] && p.content[lang].enabled }).map(a => a).sort((a, b) => { return a.rating < b.rating ? 1 : -1; }).slice(0, 6);
        }
    },
    data() {
        return {
            content_path: "/src/apps/iwep.kz/content/"

        }
    }
}
</script>
<style lang="css" scoped>
.most-popular {
    background: whitesmoke;
    overflow: hidden;

}

.post .preview {
    background-size: cover;
    background-position: center;
    margin-bottom: 4px;
}

.post {
    /*border:1px solid lightgrey;*/
    display: inline-block;
    vertical-align: top;
    text-align: left;
    font-size: 12px;
    white-space: normal;
    cursor: pointer;
    transition: 0.3s all ease;
    margin-bottom: 20px;

}

.title {
    font-size: 18px;
}

.post:hover {
    transform: scale(1.05)
}
</style>